import Image from 'app/Components/Shared/Image/image';
import React, { useEffect,useState } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderSmallSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderSmallSize';
import { buildUrlAndOpenSameWindow } from '../../../../../utilities/StringHelpers/StringHelpers';

import iconlight from '../../images/icon-light.svg';
import success_icon from '../../images/success_icon.svg';

import { goToNextPageAsync } from '../../ServiceAppointmentAsyncthunk';

const TechnicianSuccessPage = (props) => {


    function handleOnClickCancelOrUpdateTechnician(){
        buildUrlAndOpenSameWindow(props.buttonCancelUpdate);
    }

    function handleOnContinue(){
        props.goToNextPageAsync();
    }

  return (
      <div className='technician-success-page'>
        <div className='content'>
        <Image className='info-img' src={success_icon} />
        <div className='title-wrapper'>
            <h1>היי {props.firstName}, הטכנאי שהזמנת יגיע</h1>
            <h2>קבענו ליום {props.selectedTechnicianTimeDisplay}</h2>
            <h3 className='bold'>ב{props.fullAddress}</h3>
        </div>
        <div className='detail-wrapper'>
            <div className='detail-title'>חשוב לנו להדגיש</div>
              <div className='info'>
                <Image className='info-img' src={iconlight} />
                <div className='info-text bold'>בזמן ביקור הטכנאי, חייב להיות בבית מבוגר מעל גיל 18</div>
              </div>
              <div className='info'>
                <Image className='info-img' src={iconlight} />
                <div className='info-text'>ניתן לעדכן או לבטל את מועד הטכנאי עד שעתיים לפני המועד</div>

              </div>
          </div>
        </div>
          <div className='button-wrapper'>
            <BtnSubmit
                isBusiness={false}
                text={'הבנתי, תודה'}
                onclick={handleOnContinue}
                formid='technician-page'
                isDisplayArrows={false}
            />
            <div className='update-cancel-technician-btns'>
            <BtnWhiteBlackBorderSmallSize
                text={`לעדכון מועד טכנאי`}
                onclick={handleOnClickCancelOrUpdateTechnician}
              />
            <BtnWhiteBlackBorderSmallSize
                text={`לביטול טכנאי`}
                onclick={handleOnClickCancelOrUpdateTechnician}
              />
            </div>
        </div>
      </div>
  );
};

const mapStateToProps = (state) => {
  return {
    firstName: state.authentication.loginData?.userDetails?.firstName,
    fullAddress: state.serviceAppointmentSchedulerBlock.subscriber?.address?.fullAddress,
    selectedTechnicianTimeDisplay: state.serviceAppointmentSchedulerBlock.technicianPage?.selectedTechnicianTimeDisplay,
    buttonCancelUpdate: state.serviceAppointmentSchedulerBlock?.dataEpi.buttonCancelUpdate
};
}

const mapDispatchToProps = { goToNextPageAsync};

export default connect(mapStateToProps, mapDispatchToProps)(TechnicianSuccessPage);
